import React, { useState } from "react";
import "codemirror/lib/codemirror.css";
import "codemirror/theme/material.css";
import "codemirror/mode/xml/xml";
import "codemirror/mode/javascript/javascript";
import "codemirror/mode/css/css";
import { Controlled as ControlledEditor } from "react-codemirror2";
import { FaCheckCircle, FaPlayCircle, FaExpand, FaCompress, FaChartLine } from "react-icons/fa";
import LogicStatisticsModal from "./LogicStatisticsModal";

function Taxrirlovchi(qiymati) {
  const { til, nomi, qiymat, kodYozish, Natija, rasm, video, onVideoClick, darkMode, headerContent } = qiymati;
  const [isExpanded, setIsExpanded] = useState(false);
  const [showStats, setShowStats] = useState(false);

  function kodYoz(taxrir, vaqt, qiymat) {
    kodYozish(qiymat);
  }

  const toggleFullscreen = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div
      className={`tarxirlovchi-quti ${isExpanded ? "fullscreen-editor" : ""}`}
      onPaste={(e) => { e.preventDefault(); return false; }}
      onCopy={(e) => { e.preventDefault(); return false; }}
      onCut={(e) => { e.preventDefault(); return false; }}
      onDrop={(e) => { e.preventDefault(); return false; }}
      onContextMenu={(e) => { e.preventDefault(); return false; }}
    >
      <div className="tarxirlovchi-sarlavha">
        <img src={rasm} alt={til} />
        <span>{nomi}</span>
        {/* Helper Content (Timer) */}
        {headerContent}
        <button
          type="button"
          onMouseDown={(e) => {
            e.preventDefault();
            e.stopPropagation();
            return false;
          }}
          onClick={(e) => {
            if (e) {
              e.preventDefault();
              e.stopPropagation();
              if (e.nativeEvent && e.nativeEvent.stopImmediatePropagation) e.nativeEvent.stopImmediatePropagation();
            }
            onVideoClick();
            return false;
          }}
          className="video-yordam-tugma"
          title="Video yordamni ko'rish"
          style={{ cursor: 'pointer', display: 'inline-flex', alignItems: 'center' }}
        >
          <FaPlayCircle /> &nbsp;Video yordam
        </button>

        <button
          type="button"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            Natija("", "", qiymat);
          }}
          className="buyurtma-tugma"
        >
          <FaCheckCircle /> &nbsp;Bajarish
        </button>
        <div
          onClick={toggleFullscreen}
          className="fullscreen-tugma"
          title={isExpanded ? "Kichraytirish" : "Kengaytirish"}
          style={{
            background: 'transparent', border: 'none', color: '#fff',
            fontSize: '1.2rem', cursor: 'pointer', display: 'flex', alignItems: 'center',
            marginLeft: '10px', padding: '0'
          }}
        >
          {isExpanded ? <FaCompress /> : <FaExpand />}
        </div>
      </div>
      <ControlledEditor
        onBeforeChange={kodYoz}
        editorDidMount={(editor) => {
          editor.on('paste', (cm, e) => { e.preventDefault(); });
          editor.on('copy', (cm, e) => { e.preventDefault(); });
          editor.on('cut', (cm, e) => { e.preventDefault(); });
          editor.on('contextmenu', (cm, e) => { e.preventDefault(); });
          editor.on('drop', (cm, e) => { e.preventDefault(); });
        }}
        value={qiymat}
        className="taxrirlovchi"
        options={{
          lineWrapping: true,
          lint: true,
          mode: til,
          size: 70,
          fontSize: 25,
          theme: "material",
          lineNumbers: true,
          extraKeys: {
            "Ctrl-V": () => false,
            "Cmd-V": () => false,
            "Ctrl-C": () => false,
            "Cmd-C": () => false,
            "Ctrl-X": () => false,
            "Cmd-X": () => false,
            "Ctrl-Ins": () => false, // Copy
            "Shift-Ins": () => false, // Paste
            "Shift-Del": () => false // Cut
          }
        }}
      />
      <LogicStatisticsModal
        isOpen={showStats}
        onClose={() => setShowStats(false)}
      />
    </div>
  );
}

export default Taxrirlovchi;
